export const DEFAULT_TESTS_DATA =[
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Haemoglobin (Hb)",
            "value": "",
            "units": "Gms/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "MALE",
                        "min": "13",
                        "max": "17",
                        "unit": "Gms/dL"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "FEMALE",
                        "min": "12",
                        "max": "15",
                        "unit": "Gms/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Neutrophils",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "40",
                        "max": "75",
                        "unit": "%"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Total WBC Count",
            "value": "",
            "units": "cells/mm³",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "4000",
                        "max": "11000",
                        "unit": "cells/mm³"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Total Lymphocytes",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "20",
                        "max": "40",
                        "unit": "%"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Eosinophils",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "1",
                        "max": "6",
                        "unit": "%"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Monocytes",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "2",
                        "max": "10",
                        "unit": "%"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Total Red Cell Count (RBC)",
            "value": "",
            "units": "M cells/mm³",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "FEMALE",
                        "value": "FEMALE",
                        "min": "3.8",
                        "max": "4.8",
                        "unit": "M cells/mm³"
                    },
                    {
                        "gender": "MALE",
                        "value": "MALE",
                        "min": "3.5",
                        "max": "4.5",
                        "unit": "M cells/mm³"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Erythrocyte Sedimentation Rate (ESR)",
            "value": "",
            "units": "mm/hour",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "9",
                        "unit": "mm/hour"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "PBS (Peripheral Blood Smear)",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Platelets Count",
            "value": "",
            "units": " Lac cells/mm³",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "1.5",
                        "max": "4.1",
                        "unit": "Lac cells/mm³"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Haematocrit (PCV)",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "MALE",
                        "min": "40",
                        "max": "52",
                        "unit": "%"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "FEMALE",
                        "min": "36",
                        "max": "47",
                        "unit": "%"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Mean Corpuscular Volume (MCV)",
            "value": "",
            "units": "fL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "75",
                        "max": "95",
                        "unit": "fL"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Mean Corpuscular Haemoglobin (MCH)",
            "value": "",
            "units": "pg",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "26",
                        "max": "32",
                        "unit": "pg"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Mean Corpuscular Haemoglobin Concentration (MCHC)",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "31",
                        "max": "35",
                        "unit": "%"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Count - CBC",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "Haemoglobin (Hb)",
            "value": "",
            "units": "Gms/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "MALE",
                        "min": "13",
                        "max": "17",
                        "unit": "Gms/dL"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "FEMALE",
                        "min": "12",
                        "max": "15",
                        "unit": "Gms/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "Haematocrit (PCV)",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "FEMALE",
                        "value": "FEMALE",
                        "min": "36",
                        "max": "47",
                        "unit": "%"
                    },
                    {
                        "gender": "MALE",
                        "value": "MALE",
                        "min": "40",
                        "max": "52",
                        "unit": "%"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "Total Red Cell Count (RBC)",
            "value": "",
            "units": "M cells/mm³",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "FEMALE",
                        "value": "FEMALE",
                        "min": "3.8",
                        "max": "4.8",
                        "unit": "M cells/mm³"
                    },
                    {
                        "gender": "MALE",
                        "value": "MALE",
                        "min": "3.5",
                        "max": "4.5",
                        "unit": "M cells/mm³"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "RBCs",
            "value": "",
            "units": "M cells/µL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "4",
                        "max": "6",
                        "unit": "M cells/µL"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "4",
                        "max": "5.5",
                        "unit": "M cells/µL"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "WBCs",
            "value": "",
            "units": "K cells/µL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "4",
                        "max": "11",
                        "unit": "K cells/µL"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "Platelets",
            "value": "",
            "units": "K cells/µL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "150",
                        "max": "450",
                        "unit": "K cells/µL"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "Differential Count",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "Peripheral Blood Smear",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "Total WBC Count",
            "value": "",
            "units": "cells/mm³",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "4000",
                        "max": "11000",
                        "unit": "cells/mm³"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "Neutrophils",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "40",
                        "max": "75",
                        "unit": "%"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "Lymphocytes",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "20",
                        "max": "40",
                        "unit": "%"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "Eosinophils",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "1",
                        "max": "6",
                        "unit": "%"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "Basophils",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "2",
                        "unit": "%"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "Monocytes",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "2",
                        "max": "10",
                        "unit": "%"
                    }
                ]
            }
        },
        {
            "reportName": "Complete Blood Picture - CBP",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        },
            {
                "reportName": "Diabetes Profile ",
                "testName": "Fasting Blood Sugar (FBS)",
                "value": "",
                "units": "mg/dL",
                "arrowDirection": "",
                "refRange": {
                    "isConditional": true,
                    "ranges": [
                        {
                            "gender": "ALL",
                            "value": "Normal",
                            "min": "70",
                            "max": "126",
                            "unit": "mg/dL"
                        }
                    ]
                }
            },
            {
                "reportName": "Diabetes Profile ",
                "testName": "Post Prandial Blood Sugar (PPBS)",
                "value": "",
                "units": "mg/dL",
                "arrowDirection": "",
                "refRange": {
                    "isConditional": true,
                    "ranges": [
                        {
                            "gender": "ALL",
                            "value": "Normal",
                            "min": "100",
                            "max": "200",
                            "unit": "mg/dL"
                        }
                    ]
                }
            },
            {
                "reportName": "Diabetes Profile ",
                "testName": "Glycosylated Haemoglobin - HbA1c",
                "value": "",
                "units": "%",
                "arrowDirection": "",
                "refRange": {
                    "isConditional": false,
                    "ranges": [
                        {
                            "gender": "ALL",
                            "value": "Normal Non Diabetic Level",
                            "min": "0",
                            "max": "6",
                            "unit": "%"
                        }
                    ]
                }
            },
            {
                "reportName": "Diabetes Profile ",
                "testName": "RBS (Random Blood Sugar)",
                "value": "",
                "units": "",
                "arrowDirection": "",
                "refRange": {
                    "isConditional": false,
                    "ranges": [
                        {
                            "gender": "",
                            "value": "",
                            "min": "",
                            "max": "",
                            "unit": ""
                        }
                    ]
                }
            },
            {
                "reportName": "Diabetes Profile ",
                "testName": "Mean Blood Glucose ",
                "value": "",
                "units": "mg/dL",
                "arrowDirection": "",
                "refRange": {
                    "isConditional": false,
                    "ranges": [
                        {
                            "gender": "ALL",
                            "value": "Normal Non Diabetic Level",
                            "min": "70",
                            "max": "125",
                            "unit": "mg/dL"
                        }
                    ]
                }
            },
            {
                "reportName": "Diabetes Profile ",
                "testName": "Glucose Urine ",
                "value": "",
                "units": "",
                "arrowDirection": "",
                "refRange": {
                    "isConditional": false,
                    "ranges": [
                        {
                            "gender": "",
                            "value": "",
                            "min": "",
                            "max": "",
                            "unit": ""
                        }
                    ]
                }
            },
            {
                "reportName": "Diabetes Profile ",
                "testName": "Fasting Glucose, Urine ",
                "value": "",
                "units": "",
                "arrowDirection": "",
                "refRange": {
                    "isConditional": false,
                    "ranges": [
                        {
                            "gender": "",
                            "value": "",
                            "min": "",
                            "max": "",
                            "unit": ""
                        }
                    ]
                }
            },
            {
                "reportName": "Diabetes Profile ",
                "testName": "2 Post Meal Glucose, Urine (Presence)",
                "value": "",
                "units": "",
                "arrowDirection": "",
                "refRange": {
                    "isConditional": false,
                    "ranges": [
                        {
                            "gender": "",
                            "value": "",
                            "min": "",
                            "max": "",
                            "unit": ""
                        }
                    ]
                }
            },
            {
                "reportName": "Diabetes Profile ",
                "testName": "Remarks",
                "value": "",
                "units": "",
                "arrowDirection": "",
                "refRange": "",
                "recentlyUpdated": true
            },
        {
            "reportName": "Thyroid Profile",
            "testName": "TSH (Thyroid Stimulating Hormone)",
            "value": "",
            "units": "mIU/L",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "FEMALE",
                        "value": "21 Weeks - 20 yrs",
                        "min": "0.7",
                        "max": "6.4",
                        "unit": "mIU/L"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "21 - 54 yrs",
                        "min": "0.4",
                        "max": "4.2",
                        "unit": "mIU/L"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "55 - 87 yrs",
                        "min": "0.5",
                        "max": "8.9",
                        "unit": "mIU/L"
                    }
                ]
            }
        },
        {
            "reportName": "Free Thyroid Profile",
            "testName": "TSH (Thyroid Stimulating Hormone)",
            "value": "",
            "units": "mIU/L",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "21 WEEKS - 20 YEARS ",
                        "min": "0.7",
                        "max": "6.4",
                        "unit": "mIU/L"
                    },
                    {
                        "gender": "ALL",
                        "value": "21 YEARS - 54 YEARS",
                        "min": "0.4",
                        "max": "4.2",
                        "unit": "mIU/L"
                    },
                    {
                        "gender": "ALL",
                        "value": "55 YEARS - 87 YEARS",
                        "min": "0.5",
                        "max": "8.9",
                        "unit": "mIU/L"
                    }
                ]
            }
        },
        {
            "reportName": "Thyroid Profile",
            "testName": "T3",
            "value": "",
            "units": "ng/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "80",
                        "max": "220",
                        "unit": "ng/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Thyroid Profile",
            "testName": "T4",
            "value": "",
            "units": "µg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "4.9",
                        "max": "11.7",
                        "unit": "µg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Free Thyroid Profile",
            "testName": "Free T3",
            "value": "",
            "units": "ng/mL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0.6",
                        "max": "1.6",
                        "unit": "ng/mL"
                    }
                ]
            }
        },
        {
            "reportName": "Free Thyroid Profile",
            "testName": "Free T4",
            "value": "",
            "units": "ng/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0.89",
                        "max": "1.76",
                        "unit": "ng/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Thyroid Profile",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        },
        {
            "reportName": "Free Thyroid Profile",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        },
        {
            "reportName": "Fasting Lipid Profile  FLP",
            "testName": "Serum Cholesterol",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "200",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Fasting Lipid Profile  FLP",
            "testName": "Serum Triglycerides",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "60",
                        "max": "150",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Fasting Lipid Profile  FLP",
            "testName": "Serum HDL Cholesterol",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "45",
                        "max": "",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Fasting Lipid Profile  FLP",
            "testName": "Serum LDL Cholesterol",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "100",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Fasting Lipid Profile  FLP",
            "testName": "Serum VLDL Cholesterol",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "20",
                        "max": "40",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Fasting Lipid Profile  FLP",
            "testName": "Total Cholesterol/ HDL Ratio",
            "value": "",
            "units": "Ratio",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "4.5",
                        "unit": "Ratio"
                    }
                ]
            }
        },
        {
            "reportName": "Fasting Lipid Profile  FLP",
            "testName": "Non HDL Cholesterol",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "130",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Non Fasting Lipid Profile",
            "testName": "Serum Cholesterol (Non Fasting)",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "200",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Non Fasting Lipid Profile",
            "testName": "Serum Triglycerides (Non Fasting)",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "60",
                        "max": "170",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Non Fasting Lipid Profile",
            "testName": "Serum HDL Cholesterol (Non Fasting)",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "45",
                        "max": "",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Non Fasting Lipid Profile",
            "testName": "Serum LDL Cholesterol (Non Fasting)",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "100",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Non Fasting Lipid Profile",
            "testName": "Serum VLDL Cholesterol (Non Fasting)",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "20",
                        "max": "40",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Non Fasting Lipid Profile",
            "testName": "Total Cholesterol/ HDL Ratio (Non Fasting)",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "",
                        "max": "4.5",
                        "unit": "Ratio"
                    }
                ]
            }
        },
        {
            "reportName": "Non Fasting Lipid Profile",
            "testName": "Non HDL Cholesterol (Non Fasting)",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "",
                        "max": "130",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Lipid Profile",
            "testName": "Total Cholesterol/HDL Ratio",
            "value": "",
            "units": "Ratio",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "4.5",
                        "unit": "Ratio"
                    }
                ]
            }
        },
        {
            "reportName": "Lipid Profile",
            "testName": "Serum VLDL Cholesterol",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "20",
                        "max": "40",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Fasting Lipid Profile  FLP",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        },
        {
            "reportName": "Non Fasting Lipid Profile",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        },
        {
            "reportName": "Lipid Profile",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        },
        {
            "reportName": "Kidney Function Test - KFT",
            "testName": "Urine Creatinine",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "FEMALE",
                        "value": "FEMALE",
                        "min": "20",
                        "max": "320",
                        "unit": "mg/dL"
                    },
                    {
                        "gender": "MALE",
                        "value": "MALE",
                        "min": "20",
                        "max": "370",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Kidney Function Test - KFT",
            "testName": "Estimated Protein Excretion",
            "value": "",
            "units": "g/day",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Kidney Function Test - KFT",
            "testName": "Urine Protein Excretion",
            "value": "",
            "units": "g/day",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "150",
                        "unit": "g/day"
                    }
                ]
            }
        },
        {
            "reportName": "Kidney Function Test - KFT",
            "testName": "Protein/Creatinine Ratio",
            "value": "",
            "units": "Ratio",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0.2",
                        "max": "2",
                        "unit": "Ratio"
                    }
                ]
            }
        },
        {
            "reportName": "Kidney Function Test - KFT",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        },
        {
            "reportName": "Liver Function Tests - LFT",
            "testName": "Serum Alkaline Phosphatase",
            "value": "",
            "units": "IU/L",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "Children (3-15 Yrs)",
                        "min": "151",
                        "max": "471",
                        "unit": "IU/L"
                    },
                    {
                        "gender": "ALL",
                        "value": "Adult",
                        "min": "46",
                        "max": "116",
                        "unit": "IU/L"
                    }
                ]
            }
        },
        {
            "reportName": "Liver Function Tests - LFT",
            "testName": "Serum Bilirubin Total",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0.2",
                        "max": "1",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Liver Function Tests - LFT",
            "testName": "Serum Bilirubin Direct",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "0.2",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Liver Function Tests - LFT",
            "testName": "Bilirubin Indirect",
            "value": "",
            "units": "mg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0.1",
                        "max": "0.9",
                        "unit": "mg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Liver Function Tests - LFT",
            "testName": "SGOT (AST)",
            "value": "",
            "units": "IU/L",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "40",
                        "unit": "IU/L"
                    }
                ]
            }
        },
        {
            "reportName": "Liver Function Tests - LFT",
            "testName": "SGPT (AST)",
            "value": "",
            "units": "IU/L",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "40",
                        "unit": "IU/L"
                    }
                ]
            }
        },
        {
            "reportName": "Liver Function Tests - LFT",
            "testName": "Serum Protein  Total",
            "value": "",
            "units": "g/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "6.6",
                        "max": "8.4",
                        "unit": "g/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Liver Function Tests - LFT",
            "testName": "Serum Protein  Albumin",
            "value": "",
            "units": "g/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "3.5",
                        "max": "5",
                        "unit": "g/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Liver Function Tests - LFT",
            "testName": "Serum Protein  Globulin",
            "value": "",
            "units": "g/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "1.5",
                        "max": "3",
                        "unit": "g/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Liver Function Tests - LFT",
            "testName": "Serum Albumin/Globulin Ratio",
            "value": "",
            "units": "Ratio",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "1.5",
                        "max": "2.5 : 1",
                        "unit": "Ratio"
                    }
                ]
            }
        },
        {
            "reportName": "Liver Function Tests - LFT",
            "testName": "Gamma Glutamyl Transpeptidase (GGT)",
            "value": "",
            "units": "IU/L",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "0",
                        "max": "66",
                        "unit": "IU/L"
                    }
                ]
            }
        },
        {
            "reportName": "Liver Function Tests - LFT",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        },
        {
            "reportName": "Fever Profile",
            "testName": "Malarial parasite Antigen Test",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Fever Profile",
            "testName": "PBS (Peripheral Blood Smear)",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Fever Profile",
            "testName": "Dengue NS-1 (Qualitative)",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Fever Profile",
            "testName": "Dengue IgG, Serum (Qualitative)",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Fever Profile",
            "testName": "Dengue IgM, Serum (Qualitative)",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Fever Profile",
            "testName": "Widal (Slide Test)",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Fever Profile",
            "testName": "Typhidot G Test",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Fever Profile",
            "testName": "Typhidot M Test",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Fever Profile",
            "testName": "SARS CoV-2 RNA (Presence)",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Fever Profile",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        },
        {
            "reportName": "Fertility/PCOS Profile",
            "testName": "DHEA - De Hydro Epiandrostenedione",
            "value": "",
            "units": "µg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "45",
                        "max": "320",
                        "unit": "µg/dL"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "31",
                        "max": "701",
                        "unit": "µg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Fertility/PCOS Profile",
            "testName": "Follicle Stimulating Hormone (FSH)",
            "value": "",
            "units": "mIU/mL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "(0-12 yrs)",
                        "min": "0",
                        "max": "5",
                        "unit": "mIU/ml"
                    },
                    {
                        "gender": "MALE",
                        "value": "(12-18 yrs)",
                        "min": "0.3",
                        "max": "10",
                        "unit": "mIU/ml"
                    },
                    {
                        "gender": "MALE",
                        "value": "(18+ yrs)",
                        "min": "1.5",
                        "max": "12.4",
                        "unit": "mIU/ml"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "(<12 yrs)",
                        "min": "0",
                        "max": "4",
                        "unit": "mIU/ml"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "(<12 yrs)",
                        "min": "0.3",
                        "max": "10",
                        "unit": "mIU/ml"
                    }
                ]
            }
        },
        {
            "reportName": "Fertility/PCOS Profile",
            "testName": "Prolactin, Serum",
            "value": "",
            "units": "ng/mL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "0",
                        "max": "20",
                        "unit": "ng/mL"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "0",
                        "max": "400",
                        "unit": "ng/mL"
                    }
                ]
            }
        },
        {
            "reportName": "Fertility/PCOS Profile",
            "testName": "Testosterone Free",
            "value": "",
            "units": "nmol/L",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "0.2",
                        "max": "0.62",
                        "unit": "nmol/L"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "0.001",
                        "max": "0.02",
                        "unit": "nmol/L"
                    }
                ]
            }
        },
        {
            "reportName": "Fertility/PCOS Profile",
            "testName": "Testosterone, Serum",
            "value": "",
            "units": "ng/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "300",
                        "max": "1000",
                        "unit": "ng/dL"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "15",
                        "max": "70",
                        "unit": "ng/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Fertility/PCOS Profile",
            "testName": "DHT (Dihydrotestosterone)",
            "value": "",
            "units": "ng/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "30",
                        "max": "85",
                        "unit": "ng/dL"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "4",
                        "max": "22",
                        "unit": "ng/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Fertility/PCOS Profile",
            "testName": "Androstenedione",
            "value": "",
            "units": "ng/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "0.75",
                        "max": "3",
                        "unit": "ng/dL"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "0.75",
                        "max": "3",
                        "unit": "ng/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Fertility/PCOS Profile",
            "testName": "DHEA (Dehydroepiandrosterone), Serum",
            "value": "",
            "units": "ng/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "160",
                        "max": "449",
                        "unit": "ng/dL"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "98",
                        "max": "340",
                        "unit": "ng/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Fertility/PCOS Profile",
            "testName": "Progesterone, Serum",
            "value": "",
            "units": "ng/mL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "0.1",
                        "max": "0.6",
                        "unit": "ng/dL"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "0.2",
                        "max": "27",
                        "unit": "ng/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Fertility/PCOS Profile",
            "testName": "17-OH Progesterone, Serum",
            "value": "",
            "units": "ng/mL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "Male",
                        "value": "",
                        "min": "0.1",
                        "max": "0.6",
                        "unit": "ng/dL"
                    },
                    {
                        "gender": "Female",
                        "value": "",
                        "min": "0.2",
                        "max": "27",
                        "unit": "ng/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Fertility/PCOS Profile",
            "testName": "SHBG (Sex Hormone Binding Globulin)",
            "value": "",
            "units": "nmol/L",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "10",
                        "max": "57",
                        "unit": "nmol/L"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "18",
                        "max": "144",
                        "unit": "nmol/L"
                    }
                ]
            }
        },
        {
            "reportName": "Fertility/PCOS Profile",
            "testName": "Estradiol",
            "value": "",
            "units": "pg/mL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "10",
                        "max": "40",
                        "unit": "pg/mL"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "10",
                        "max": "370",
                        "unit": "pg/mL"
                    }
                ]
            }
        },
        {
            "reportName": "Fertility/PCOS Profile",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        },
        {
            "reportName": "Pulmonary Function Test",
            "testName": "Forced Vital Capacity (FVC)",
            "value": "",
            "units": "mL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Pulmonary Function Test",
            "testName": "FEV1",
            "value": "",
            "units": "mL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Pulmonary Function Test",
            "testName": "FEV1/FVC",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Pulmonary Function Test",
            "testName": "Vital Capacity (VC)",
            "value": "",
            "units": "mL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Pulmonary Function Test",
            "testName": "Forced Expiratory Time (FET)",
            "value": "",
            "units": "s",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Pulmonary Function Test",
            "testName": "PEFR (Peak Expiratory Flow Rate)",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Pulmonary Function Test",
            "testName": "Inspiratory Capacity (IC)",
            "value": "",
            "units": "mL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Pulmonary Function Test",
            "testName": "Exhaled Nitric Oxide (NO) Test",
            "value": "",
            "units": "[ppb]",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Pulmonary Function Test",
            "testName": "Six Minute Walk Test",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Pulmonary Function Test",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        },
        {
            "reportName": "Routine Imaging & Histo",
            "testName": "ECG",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Routine Imaging & Histo",
            "testName": "2-D ECHO",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Routine Imaging & Histo",
            "testName": "X-Ray Chest - PA View",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Routine Imaging & Histo",
            "testName": "USG Abdomen and Pelvis",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Routine Imaging & Histo",
            "testName": "USG (Ultrasonography)",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Routine Imaging & Histo",
            "testName": "FNAC",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Routine Imaging & Histo",
            "testName": "Histopathology Report",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Routine Imaging & Histo",
            "testName": "Biopsy Report",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "",
                        "value": "",
                        "min": "",
                        "max": "",
                        "unit": ""
                    }
                ]
            }
        },
        {
            "reportName": "Routine Imaging & Histo",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        },
        {
            "reportName": "Iron Profile",
            "testName": "Iron, Serum",
            "value": "",
            "units": "µg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "65",
                        "max": "176",
                        "unit": "µg/dL"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "50",
                        "max": "170",
                        "unit": "µg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Iron Profile",
            "testName": "TIBC (Total Iron Binding Capacity)",
            "value": "",
            "units": "µg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "240",
                        "max": "450",
                        "unit": "µg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Iron Profile",
            "testName": "UIBC (Unsaturated Iron Binding Capacity)",
            "value": "",
            "units": "µg/dL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": false,
                "ranges": [
                    {
                        "gender": "ALL",
                        "value": "",
                        "min": "150",
                        "max": "375",
                        "unit": "µg/dL"
                    }
                ]
            }
        },
        {
            "reportName": "Iron Profile",
            "testName": "Transferrin Saturation, Serum",
            "value": "",
            "units": "%",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "20",
                        "max": "50",
                        "unit": "%"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "15",
                        "max": "50",
                        "unit": "%"
                    }
                ]
            }
        },
        {
            "reportName": "Iron Profile",
            "testName": "Ferritin, Serum",
            "value": "",
            "units": "ng/mL",
            "arrowDirection": "",
            "refRange": {
                "isConditional": true,
                "ranges": [
                    {
                        "gender": "MALE",
                        "value": "",
                        "min": "30",
                        "max": "400",
                        "unit": "ng/mL"
                    },
                    {
                        "gender": "FEMALE",
                        "value": "",
                        "min": "13",
                        "max": "150",
                        "unit": "ng/mL"
                    }
                ]
            }
        },
        {
            "reportName": "Iron Profile",
            "testName": "Remarks",
            "value": "",
            "units": "",
            "arrowDirection": "",
            "refRange": "",
            "recentlyUpdated": true
        }
]